/**
 * Overlay
 */

/**
 * Functionality for the custom overlays
 *
 * @author Yonita van Oudheusden <yonita@click.nl>
 * @return void
 */

window.overlay = function() {
    var self                            = this;
    var $reveal_quotation_overlay       = $('.js-reveal-quotation-overlay');
    var $reveal_boxes_overlay           = $('.js-reveal-boxes-overlay');
    var $reveal_reviews_overlay         = $('.js-reveal-reviews-overlay');
    var $quotation_overlay_wrapper      = $('.js-quotation-overlay-wrapper');
    var $boxes_overlay_wrapper          = $('.js-boxes-overlay-wrapper'); 
    var $reviews_overlay_wrapper        = $('.js-reviews-overlay-wrapper'); 

    self.init = function() {
        $reveal_quotation_overlay.click(self.revealQuotationOverlay);
        $reveal_boxes_overlay.click(self.revealBoxesOverlay);
        $reveal_reviews_overlay.click(self.revealReviewsOverlay);
    };

    self.revealQuotationOverlay = function() {
        if( $quotation_overlay_wrapper.hasClass('is-active') ){
            $quotation_overlay_wrapper.removeClass('is-active');
        } else {
            $quotation_overlay_wrapper.addClass('is-active'); 
        }
    };

    self.revealBoxesOverlay = function() {
        if( $boxes_overlay_wrapper.hasClass('is-active') ){
            $boxes_overlay_wrapper.removeClass('is-active');
        } else {
            $boxes_overlay_wrapper.addClass('is-active');
        }
    };

    self.revealReviewsOverlay = function() {
        if( $reviews_overlay_wrapper.hasClass('is-active') ){
            $reviews_overlay_wrapper.removeClass('is-active');
        } else {
            $reviews_overlay_wrapper.addClass('is-active');
        }
    };
}


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/components/overlay.js